import request from "@/utils/request";


// 合服建议列表
export function suggestionListApi(data) {
    return request({
      url: "/admin/server_merge_suggestion",
      method: "get",
      params: data
    });
}

// 合服建议-添加
export function addSuggestionApi(data) {
  return request({
    url: "/admin/server_merge_suggestion",
    method: "post",
    data
  });
}

// 合服建议-修改(获取)
export function getSuggestionApi(data) {
  return request({
    url: "/admin/server_merge_suggestion/" + data.id,
    method: "get",
    params: data
  });
}

// 合服建议-修改(提交)
export function putSuggestionApi(data) {
  return request({
    url: "/admin/server_merge_suggestion/" + data.id,
    method: "put",
    data
  });
}

//  合服建议-删除
export function deleteSuggestionApi(data) {
  return request({
    url: "/admin/server_merge_suggestion/" + data.id,
    method: "delete",
    data
  });
}

// 合服建议-回复
export function replySuggestionApi(data) {
  return request({
    url: "/admin/reply_suggestion/" + data.id,
    method: "post",
    data
  });
}

// 合服建议-下载导入模板
export function excelDownloadApi() {
  return request({
    url: "/suggestion_excel_download",
    method: "get",
  });
}

// 合服建议-批量上传
export function uploadSuggestionApi(data) {
  return request({
    url: "/admin/upload_suggestion",
    method: "post",
    data
  });
}

// 合服建议-获取下拉框
export function getSelectApi(data) {
  return request({
    url: "/admin/get_suggestion_select",
    method: "get",
    params: data
  });
}


// 合服建议-获取来源权限
export function getPermissionApi() {
  return request({
    url: "/admin/get_merge_submit_permission",
    method: "get",
  });
}

// 获取VIP分组数据
export function getVipSelectApi() {
  return request({
    url: "/admin/get_suggestion_admin_select",
    method: "get",
  });
}

// 发送通知
export function sendeNoticeApi(data) {
  return request({
    url: "/admin/notice_suggestion",
    method: "post",
    data
  });
}

// 批量回复
export function lotEvaluateApi(data) {
  return request({
    url: "/admin/batch_evaluation",
    method: "put",
    params: data
  });
}

